import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../../../features/auth";
import { PATHS } from "../../../routes/paths";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, isInitialized, user, logout } = useAuthStore();
  const location = useLocation();
  console.log(isAuthenticated)
  if (!isInitialized || isLoading) return <></>;

  if (user?.archivedAt) {
    logout('archived');
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={PATHS.login} replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
